import type { SVGProps } from "react";

export function IconBlue3Packages(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M44.5 7H19.5V32H7V57H32H57V32H44.5V7Z"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M32 57V30.5M32 30.5H19.5V37M32 30.5H44.5V37M32 7V12"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
